import React from 'react';
import { IconProps } from '.';

const SvgBoxSelected = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill='#000'
        d='M2 5.022A3.016 3.016 0 0 1 5.01 2h13.98A3.016 3.016 0 0 1 22 5.022v13.956A3.016 3.016 0 0 1 18.99 22H5.01A3.016 3.016 0 0 1 2 18.978V5.022Z'
      />
      <path
        fill='#fff'
        d='M9.718 14.714c0 .406.064.752.193 1.04.128.287.307.524.536.712.229.178.49.312.783.4.303.08.628.12.976.12.376 0 .697-.045.962-.134.266-.099.482-.223.646-.371.165-.149.284-.317.358-.505a1.7 1.7 0 0 0 .11-.594c0-.405-.087-.702-.261-.89a1.375 1.375 0 0 0-.55-.416 10.008 10.008 0 0 0-1.224-.386c-.458-.129-1.026-.292-1.704-.49a3.76 3.76 0 0 1-1.058-.46 2.739 2.739 0 0 1-.66-.654 2.463 2.463 0 0 1-.358-.757 3.487 3.487 0 0 1-.096-.816c0-.535.1-.995.303-1.381.21-.396.485-.722.824-.98.34-.257.724-.445 1.155-.564a4.54 4.54 0 0 1 1.306-.193c.513 0 .994.074 1.443.223.458.138.857.351 1.196.638.348.287.623.643.825 1.069.201.416.302.9.302 1.455h-1.718c-.046-.683-.261-1.163-.646-1.44-.385-.287-.875-.43-1.471-.43a2.7 2.7 0 0 0-.619.074c-.21.04-.403.113-.577.222-.174.1-.32.238-.44.416-.11.178-.165.4-.165.668 0 .376.106.673.316.89.22.209.505.367.853.476.036.01.178.054.426.133a61.782 61.782 0 0 1 1.76.505c.302.08.517.139.645.178.321.11.6.258.839.446.238.188.435.406.59.653.166.238.285.495.358.772a2.9 2.9 0 0 1 .124.831c0 .594-.114 1.104-.344 1.53-.22.415-.513.757-.88 1.024a3.61 3.61 0 0 1-1.25.579 5.36 5.36 0 0 1-1.43.193 5.472 5.472 0 0 1-1.58-.223 3.597 3.597 0 0 1-1.293-.683 3.322 3.322 0 0 1-.88-1.172c-.22-.485-.334-1.055-.343-1.708h1.718ZM12.578 4.5h1.855l-1.952 2.123h-1.14L12.576 4.5Z'
      />
    </svg>
  );
};

export default SvgBoxSelected;
